import { type Components, type Theme } from "@mui/material/styles";

export const textField: Components<Theme>["MuiTextField"] = {
  defaultProps: {
    variant: "outlined",
    size: "small",
  },
};
